import React from 'react'
import {TwCol} from '../tw-components'

interface ColProps {
  title: React.ReactNode,
  className?: string
}

export const Col = (props: ColProps) => {
  const {
    title,
    className
  } = props
  return <TwCol className={className}>{title}</TwCol>
}